var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCount1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8 30.5476H22.06V17.8076L24.5 17.7476L18.74 21.5276V18.7676L22.38 16.4076H24.8V30.5476Z",
    fill: "#8CCE34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.942 14.8735C38.6466 18.2012 39.162 22.0118 38.4027 25.6728C37.6434 29.3338 35.6551 32.625 32.7676 35.0003C29.8802 37.3756 26.2673 38.6921 22.5286 38.7314C18.79 38.7706 15.1503 37.5302 12.2136 35.216C9.27697 32.9018 7.21998 29.653 6.38402 26.0088C5.54805 22.3645 5.98339 18.544 7.61779 15.1812C9.25218 11.8185 11.9873 9.11571 15.3693 7.52151C18.7513 5.92731 22.5768 5.53753 26.2108 6.41686",
    stroke: "#8CCE34",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9024 1.35007L27.78 6.27685L23.036 12.6172",
    stroke: "#8ECE30",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCount1);
export default __webpack_public_path__ + "static/media/count-1.44b519f63fa4c7789d4b3fe70de5c095.svg";
export { ForwardRef as ReactComponent };